// new submodule
export default {
	/**
	 * prepares the data for Datamaps and then instantiates this interactive map
	 * also adds listeners for the category links so that map data gets updated according to the respective category
	 * @param {Object} visibleCountriesHash hash with all countries (or group of countries in case of EU) that must be displayed
	 * @param {Object} showEUMap determine with the map should be zoomed in on the EU countries. the highlighted countries are not directly affected by this
	 */
	initMap(visibleCountriesHash, showEUMap) {
		pp.log(
			"COUNTRY INFORMATION initMap -- visibleCountriesHash, showEUMap",
			visibleCountriesHash,
			showEUMap,
		);
		pp.mapInformation.showEUMap = showEUMap || false;

		if (pp.mapInformation.showEUMap) {
			// make map use a custom projection of Europe
			var projectionFunction = ({ offsetWidth, offsetHeight }) => {
				// @ts-expect-error
				const projection = d3.geo
					.equirectangular()
					.center([12, 41])
					.rotate([2.5, -10])
					.scale(975)
					.translate([offsetWidth / 2, offsetHeight / 2]);
				// @ts-expect-error
				const path = d3.geo.path().projection(projection);

				return {
					path,
					projection,
				};
			};
		} else {
			// make map use a custom projection of the world
			// @ts-expect-error
			var projectionFunction = (element) => {
				// @ts-expect-error
				const projection = d3.geo.times().center([-18, 20]).scale(190);
				// @ts-expect-error
				const path = d3.geo.path().projection(projection);

				return {
					path,
					projection,
				};
			};
		}

		const countryData = {};
		$.each(visibleCountriesHash, (key, val) => {
			// @ts-expect-error
			if (key.length == 3) {
				// this is alpha3 already
				countryData[key] = countryData[key] || {};
				countryData[key]["fillKey"] = "blue";
				val["alpha3"] = key;
			} else {
				// map the alpha2 keys to alpha3 that Datamap understands
				// @ts-expect-error
				const alpha3 = pp.mapInformation.countryCodesHash[key.toUpperCase()];
				if (typeof alpha3 === "string") {
					// a single country
					countryData[alpha3] = countryData[alpha3] || {};
					countryData[alpha3]["fillKey"] = "blue";
					val["alpha3"] = alpha3;
				} else if (typeof alpha3 === "object") {
					// a collection of countries (i.e. the EU)
					// @ts-expect-error
					countryData[key.toUpperCase()] = countryData[key.toUpperCase()] || {};
					$.each(alpha3, (i, el) => {
						countryData[el] = countryData[el] || {};
						countryData[el]["fillKey"] = "blue";
					});
					// @ts-expect-error
					val["alpha3"] = key.toUpperCase();
				}
			}
			if (val["name"] === undefined)
				val["name"] =
					pp.mapInformation.euCountryNames[I18n.locale][val["alpha3"]];
		});

		// remove country keys from map data if those countries are not part of the game
		const presentKeys = [];
		for (let dataKey in pp.mapInformation.mapData) {
			for (let countryKey in pp.mapInformation.mapData[dataKey]) {
				if (presentKeys.indexOf(countryKey) == -1) {
					presentKeys.push(countryKey);
				}
			}
		}

		const countryDataKeys = Object.keys(countryData);
		const diff = presentKeys.filter((i) => countryDataKeys.indexOf(i) < 0);

		for (let i in diff) {
			if (diff[i] == "UN")
				// let the UN live
				continue;
			for (let dataKey in pp.mapInformation.mapData) {
				// @ts-expect-error
				if (pp.mapInformation.mapData[dataKey][diff[i]] !== undefined)
					// @ts-expect-error
					delete pp.mapInformation.mapData[dataKey][diff[i]];
			}
		}

		// set visible countries data now, after collecting everything
		pp.mapInformation.visibleCountries = visibleCountriesHash;
		// @ts-expect-error
		pp.mapInformation.map = new Datamap({
			element: document.getElementById("interactivemap"),
			setProjection: projectionFunction,
			projection: "equirectangular",
			height: pp.mapInformation.showEUMap ? "570px" : "460px",
			geographyConfig: {
				dataUrl: null, // if not null, datamaps will fetch the map JSON (currently only supports topojson)
				hideAntarctica: true,
				borderWidth: pp.mapInformation.showEUMap ? 1 : 0,
				highlightOnHover: false,
				popupOnHover: false,
			},
			fills: {
				defaultFill: "rgb(229, 229, 229)",
				blue: "#007AB6", // corresponds to LESS' @headings-blue
				red: "#C21326",
				green: "#9EBF40", // corresponds to LESS' @voting-pro-green
			},
			data: countryData,
		});

		// click listener to set correct li elements active
		$("#data-accordion ul a").on("click", function () {
			$("#data-accordion ul a").removeClass("active");
			$(this).addClass("active");
		});

		$("#countries-accordion ul a").on("click", function () {
			$(this)
				.parent()
				[$(this).parent().hasClass("active") ? "removeClass" : "addClass"](
					"active",
				);

			// re-invoke whatever is active right now unless the actors overlay is being shown
			if ($("a.map-link.active").length == 0) {
				return;
			}

			if ($("#interactivemap").is(":visible")) {
				pp.mapInformation.composeBubbles(
					$("#data-accordion").find("a.active").data("map-key"),
				);
			} else {
				pp.mapInformation.invokePlot(
					$("#data-accordion").find("a.active").data("map-key"),
					true,
				);
			}
		});

		pp.mapInformation.composeArcData();

		if (!pp.mapInformation.showEUMap) {
			pp.mapInformation.addWorldClickListeners();
		} else {
			pp.mapInformation.addEUClickListeners();
		}

		$("#statistics-type-toggle button")
			.last()
			.on("show.bs.tab", () => {
				pp.mapInformation.hideActors();
			});

		$("#statistics-type-toggle button").on("shown.bs.tab", () => {
			if ($("a.map-link.active").length == 0) {
				$("#actors").trigger("click");
			} else {
				$("a.map-link.active").first().trigger("click");
			}
		});
	},

	composeBubbles(dataKey) {
		pp.log("COUNTRY INFORMATION compose bubbles -- dataKey:", dataKey);
		const bubblesArr = [];
		let nextItem = {};
		let valMin = Infinity;
		let valMax = 0;

		// compose the map's data for this specific dataKey if not present
		// get first country to check
		if (
			pp.mapInformation.map.options.data[
				// @ts-expect-error
				Object.keys(pp.mapInformation.map.options.data)[0]
			][dataKey] === undefined
		) {
			for (let countryKey in pp.mapInformation.mapData[dataKey]) {
				if (pp.mapInformation.map.options.data[countryKey] === undefined)
					continue;

				if (typeof pp.mapInformation.mapData[dataKey][countryKey] == "object") {
					const years = Object.keys(
						pp.mapInformation.mapData[dataKey][countryKey],
					);
					// take last year
					let i = years.length - 1;
					while (i >= 0) {
						if (
							// @ts-expect-error
							pp.mapInformation.mapData[dataKey][countryKey][years[i]] !== ""
						) {
							pp.mapInformation.map.options.data[countryKey][dataKey] =
								// @ts-expect-error
								pp.mapInformation.mapData[dataKey][countryKey][years[i]];
							break;
						}
						i--;
					}
				} else {
					pp.mapInformation.map.options.data[countryKey][dataKey] =
						pp.mapInformation.mapData[dataKey][countryKey];
				}
				// take negative values into account
				var absKey = Math.abs(
					pp.mapInformation.map.options.data[countryKey][dataKey],
				);
				if (absKey > valMax) {
					valMax = absKey;
				} else if (absKey < valMin) {
					valMin = absKey;
				}
			}
		} else {
			// just collect min and max
			for (let countryKey in pp.mapInformation.map.options.data) {
				// take negative values into account
				var absKey = Math.abs(
					pp.mapInformation.map.options.data[countryKey][dataKey],
				);
				if (absKey > valMax) {
					valMax = absKey;
				} else if (absKey < valMin) {
					valMin = absKey;
				}
			}
		}

		$.each(pp.mapInformation.visibleCountries, (key, val) => {
			if (
				pp.mapInformation.map.options.data[val.alpha3] !== undefined &&
				($("#countries-accordion").length == 0 ||
					$("#countries-accordion").find(
						// @ts-expect-error
						`li.active[data-country-code='${key}']`,
					).length != 0)
			) {
				nextItem = {
					name: val.name,
					latitude: pp.mapInformation.capitalGeoPositions[val.alpha3]["lat"],
					longitude: pp.mapInformation.capitalGeoPositions[val.alpha3]["lon"],
					radius: pp.mapInformation.mappors(
						pp.mapInformation.map.options.data[val.alpha3][dataKey],
						valMin,
						valMax,
					),
					fillKey:
						pp.mapInformation.map.options.data[val.alpha3][dataKey] >= 0
							? "red"
							: "green",
				};
				// only shorten the numbers if this is a world map
				if (pp.mapInformation.showEUMap) {
					nextItem[dataKey] =
						pp.mapInformation.map.options.data[val.alpha3][dataKey];
				} else {
					nextItem[dataKey] = numeral(
						pp.mapInformation.map.options.data[val.alpha3][dataKey],
					).format(numeral.formatWithUnit);
				}
				bubblesArr.push(nextItem);
			}
		});

		pp.mapInformation.map.bubbles(bubblesArr, {
			borderWidth: 0,
			fillOpacity: 0.65,
			popupTemplate(geo, data) {
				// pp.log(dataKey, data);
				// pp.log("conversion:", dataKey, I18n.t(`my_information.map_information.${dataKey}.popup`));
				return `<div class='hoverinfo'>${eval(I18n.t(`my_information.map_information.${dataKey}.popup`))}</div>`;
			},
		});
		pp.mapInformation.hideActors();
	},

	/**
	 * use this to convert vastly different datasets to displayable bubbles
	 * @param {Object} x the value
	 * @param {Object} valMin: lowest value displayed
	 * @param {Object} valMax: highest value displayed
	 */
	mappors(x, valMin, valMax) {
		// Y = (X-A)/(B-A) * (D-C) + C
		// 8 = minimal radius
		if (x === undefined) return 0;

		if (x < 0) x = x * -1;
		if (valMin < 0) valMin = valMin * -1;
		const desiredArea = Math.sqrt(x / Math.PI);
		const minArea = Math.sqrt(valMin / Math.PI);
		const maxArea = Math.sqrt(valMax / Math.PI);
		const radius =
			((desiredArea - minArea) / (maxArea - minArea)) * (80 - 8) + 8; // maximum radius of the bubbles is 80
		return Math.floor(radius);
	},

	hideActors() {
		$("#actorsmap").hide("slow");
		pp.mapInformation.map.arc([]);
	},

	composeArcData() {
		if (
			pp.mapInformation.actorMessageRelations === undefined ||
			pp.mapInformation.currentActorCountryCode === undefined
		)
			return;

		let originalpha3 =
			pp.mapInformation.countryCodesHash[
				pp.mapInformation.currentActorCountryCode
			];

		// pp.log("dest", originalpha3, typeof(originalpha3));
		if (typeof originalpha3 == "object") {
			// for the EU hash
			originalpha3 = pp.mapInformation.currentActorCountryCode.toUpperCase();
		}

		pp.mapInformation.arcs = [];
		for (let key in pp.mapInformation.actorMessageRelations) {
			const obj = pp.mapInformation.actorMessageRelations[key];
			let destinationalpha3 =
				pp.mapInformation.countryCodesHash[key.toUpperCase()];
			if (typeof destinationalpha3 == "object") {
				// for the EU hash
				destinationalpha3 = key.toUpperCase();
			}

			// pp.log(destination, originalpha3, key.toUpperCase(), destinationalpha3);

			if (
				pp.mapInformation.capitalGeoPositions[originalpha3] === undefined ||
				pp.mapInformation.capitalGeoPositions[destinationalpha3] === undefined
			)
				continue;

			pp.mapInformation.arcs.push({
				origin: {
					latitude: pp.mapInformation.capitalGeoPositions[originalpha3]["lat"],
					longitude: pp.mapInformation.capitalGeoPositions[originalpha3]["lon"],
				},
				destination: {
					latitude:
						pp.mapInformation.capitalGeoPositions[destinationalpha3]["lat"],
					longitude:
						pp.mapInformation.capitalGeoPositions[destinationalpha3]["lon"],
				},
				options: {
					strokeWidth: obj >= 3 ? obj / 3 : 1, // either 1px or the number of messages divided by 3
					strokeColor: "rgba(66, 66, 66, 0.66)",
				},
			});
		}
	},

	/* CONSENSUS GAME START */
	addWorldClickListeners() {
		$("#actors").on("click", (e) => {
			// no actors overlay if the line charts are shown
			e.preventDefault();
			$("a.map-link").removeClass("active");
			if ($("#interactivemap").is(":visible")) {
				$("#actorsmap").show("slow");
				pp.mapInformation.map.arc(pp.mapInformation.arcs, {
					arcSharpness: 1.5,
				});
				pp.mapInformation.map.bubbles([]);
			} else {
				pp.mapInformation.invokePlot("actorsMessages");
			}
			return;
		});

		$("a.map-link").on("click", function (event) {
			if ($("#interactivemap").is(":visible")) {
				pp.mapInformation.composeBubbles($(this).data("map-key"));
			} else {
				pp.mapInformation.invokePlot($(this).data("map-key"), false);
			}
		});

		// init arcs
		pp.mapInformation.map.arc(pp.mapInformation.arcs, {
			arcSharpness: 1.5,
		});
	},

	/* EU GAME START */
	addEUClickListeners() {
		$("a.map-link").on("click", function () {
			pp.mapInformation.composeBubbles($(this).data("map-key"));
			$("a.map-link").parent().removeClass("active");
			$(this).parent().addClass("active");
		});

		// trigger first category
		$(".eu-information ul.nav-buttons-list a").first().trigger("click"); // only for EU map
	},

	invokePlot(dataKey, omitAnimation) {
		if (pp.mapInformation.currentPlot !== undefined) {
			pp.mapInformation.currentPlot.destroy();
		}

		const plotArr = [];
		const seriesColors = [];
		let thisCountryPlotArr = [];
		let alpha2key;
		pp.mapInformation.plotSeries = []; // store this in the mapInformation object so that the function tooltipContentEditor has access
		if (dataKey == "actorsMessages") {
			// behavior for actors' messages plot
			thisCountryPlotArr = [];
			for (let date in pp.mapInformation.actorMessageDates) {
				thisCountryPlotArr.push([
					date,
					pp.mapInformation.actorMessageDates[date],
				]);
			}
			plotArr.push(thisCountryPlotArr);
		} else {
			// behavior for countries' data plots
			for (let countryKey in pp.mapInformation.mapData[dataKey]) {
				// UN needs special treatment
				if (countryKey == "UN") {
					if (
						$("#countries-accordion").length == 0 ||
						$("#countries-accordion").find(
							`li.active[data-country-code='${countryKey.toLowerCase()}']`,
						).length != 0
					) {
						pp.mapInformation.plotSeries.push(
							pp.mapInformation.visibleCountries[countryKey.toLowerCase()].name,
						);
						const $listElement = $("#countries-accordion").find(
							`li.active[data-country-code='${countryKey.toLowerCase()}']`,
						);
						const colorCode = pp.viewHelpers.detectCssRuleFor(
							$listElement,
							$listElement.find("span").attr("class"),
							// @ts-expect-error
							"background-color",
						);
						seriesColors.push(colorCode);
					} else {
						continue;
					}
				} else {
					alpha2key = pp.mapInformation.countryCodeHashReverse[countryKey];
					if (alpha2key === undefined) {
						pp.mapInformation.plotSeries.push(countryKey);
						seriesColors.push("#ff0000"); // just some color
					} else if (
						$("#countries-accordion").length != 0 &&
						!$("#countries-accordion").find(
							`li.active[data-country-code='${alpha2key.toLowerCase()}']`,
						).length
					) {
						continue; // skip this country if it is not selected
					} else {
						pp.mapInformation.plotSeries.push(
							pp.mapInformation.visibleCountries[alpha2key.toLowerCase()].name,
						);

						const $listElement = $("#countries-accordion").find(
							`li.active[data-country-code='${alpha2key.toLowerCase()}']`,
						);
						const colorCode = pp.viewHelpers.detectCssRuleFor(
							$listElement.find("span").attr("class"),
							"background-color",
						);

						seriesColors.push(colorCode);
					}
				}

				thisCountryPlotArr = [];

				for (let year in pp.mapInformation.mapData[dataKey][countryKey]) {
					if (pp.mapInformation.mapData[dataKey][countryKey][year] == "") {
						continue;
					}
					thisCountryPlotArr.push([
						year,
						pp.mapInformation.mapData[dataKey][countryKey][year],
					]);
				}
				if (thisCountryPlotArr.length > 0) {
					plotArr.push(thisCountryPlotArr);
				} else {
					pp.mapInformation.plotSeries.pop(); // remove the label that we just pushed into the array
				}
			}
		}

		// @ts-expect-error
		pp.mapInformation.currentPlot = $.jqplot("line-charts", plotArr, {
			seriesColors,
			seriesDefaults: {
				showMarker: true,
				markerOptions: {
					show: true,
					size: 6,
				},
				rendererOptions: {
					smooth: true,
					animation: {
						show: !omitAnimation,
					},
				},
			},
			grid: {
				background: "#f7f7f7",
				drawBorder: false,
				shadow: false,
				gridLineColor: "#ddd",
				gridLineWidth: 1,
			},
			axes: {
				xaxis: {
					// @ts-expect-error
					renderer: $.jqplot.DateAxisRenderer,
					// @ts-expect-error
					tickRenderer: $.jqplot.CanvasAxisTickRenderer,
					tickOptions: {
						formatString: dataKey == "actorsMessages" ? "%d %b %Y %H:%M" : "%Y",
						showLabel: true,
						angle: -30,
						textColor: "#969696", // LESS' @gray-med
					},
					autoscale: true,
				},
				yaxis: {
					rendererOptions: {
						// @ts-expect-error
						tickRenderer: $.jqplot.CanvasAxisTickRenderer,
					},
					autoscale: true,
					tickOptions: {
						fontSize: "8pt",
						textColor: "#969696", // LESS' @gray-med
						showMark: false,
						formatter: pp.mapInformation.largeNumberFormatter,
					},
				},
			},
			highlighter: {
				show: true,
				fadeTooltip: true,
				tooltipOffset: 5,
				tooltipContentEditor: pp.mapInformation.tooltipContentEditor,
			},
			cursor: {
				show: true,
				showTooltip: false,
			},
		});
	},

	// compose custom string for the line chart hover tooltip
	tooltipContentEditor(str, seriesIndex, pointIndex, plot) {
		return (
			(pp.mapInformation.plotSeries[seriesIndex] !== undefined
				? pp.mapInformation.plotSeries[seriesIndex] + ", "
				: "") + str
		);
	},

	// convert the large numbers (e.g. GDPs of billions of dollars) to a human-readable unit (with two float digits)
	largeNumberFormatter(format, value) {
		return numeral(value).format(numeral.formatWithUnit);
	},

	// hash that maps two-character-long country codes (from the backend) to three-character-long ones (for datamaps)
	// also maps 'EU' to all EU members (used in pp.mapInformation.initMap) and UN to UN
	countryCodesHash: {
		AD: "AND",
		AE: "ARE",
		AF: "AFG",
		AG: "ATG",
		AI: "AIA",
		AL: "ALB",
		AM: "ARM",
		AN: "ANT",
		AO: "AGO",
		AQ: "ATA",
		AR: "ARG",
		AS: "ASM",
		AT: "AUT",
		AU: "AUS",
		AW: "ABW",
		AX: "ALA",
		AZ: "AZE",
		BA: "BIH",
		BB: "BRB",
		BD: "BGD",
		BE: "BEL",
		BF: "BFA",
		BG: "BGR",
		BH: "BHR",
		BI: "BDI",
		BJ: "BEN",
		BL: "BLM",
		BM: "BMU",
		BN: "BRN",
		BO: "BOL",
		BR: "BRA",
		BS: "BHS",
		BT: "BTN",
		BV: "BVT",
		BW: "BWA",
		BY: "BLR",
		BZ: "BLZ",
		CA: "CAN",
		CC: "CCK",
		CD: "COD",
		CF: "CAF",
		CG: "COG",
		CH: "CHE",
		CI: "CIV",
		CK: "COK",
		CL: "CHL",
		CM: "CMR",
		CN: "CHN",
		CO: "COL",
		CR: "CRI",
		CU: "CUB",
		CV: "CPV",
		CX: "CXR",
		CY: "CYP",
		CZ: "CZE",
		DE: "DEU",
		DJ: "DJI",
		DK: "DNK",
		DM: "DMA",
		DO: "DOM",
		DZ: "DZA",
		EC: "ECU",
		EE: "EST",
		EG: "EGY",
		EH: "ESH",
		ER: "ERI",
		ES: "ESP",
		ET: "ETH",
		FI: "FIN",
		FJ: "FJI",
		FK: "FLK",
		FM: "FSM",
		FO: "FRO",
		FR: "FRA",
		FX: "FXX",
		GA: "GAB",
		GB: "GBR",
		GD: "GRD",
		GE: "GEO",
		GF: "GUF",
		GG: "GGY",
		GH: "GHA",
		GI: "GIB",
		GL: "GRL",
		GM: "GMB",
		GN: "GIN",
		GP: "GLP",
		GQ: "GNQ",
		GR: "GRC",
		GT: "GTM",
		GU: "GUM",
		GW: "GNB",
		GY: "GUY",
		HK: "HKG",
		HM: "HMD",
		HN: "HND",
		HR: "HRV",
		HT: "HTI",
		HU: "HUN",
		ID: "IDN",
		IE: "IRL",
		IL: "ISR",
		IM: "IMN",
		IN: "IND",
		IO: "IOT",
		IQ: "IRQ",
		IR: "IRN",
		IS: "ISL",
		IT: "ITA",
		JE: "JEY",
		JM: "JAM",
		JO: "JOR",
		JP: "JPN",
		KE: "KEN",
		KG: "KGZ",
		KH: "KHM",
		KI: "KIR",
		KM: "COM",
		KN: "KNA",
		KP: "PRK",
		KR: "KOR",
		KU: "KUR",
		KW: "KWT",
		KY: "KYM",
		KZ: "KAZ",
		LA: "LAO",
		LB: "LBN",
		LC: "LCA",
		LI: "LIE",
		LK: "LKA",
		LR: "LBR",
		LS: "LSO",
		LT: "LTU",
		LU: "LUX",
		LV: "LVA",
		LY: "LBY",
		MA: "MAR",
		MC: "MCO",
		MD: "MDA",
		ME: "MNE",
		MG: "MDG",
		MH: "MHL",
		MK: "MKD",
		ML: "MLI",
		MM: "MMR",
		MN: "MNG",
		MO: "MAC",
		MP: "MNP",
		MQ: "MTQ",
		MR: "MRT",
		MS: "MSR",
		MT: "MLT",
		MU: "MUS",
		MV: "MDV",
		MW: "MWI",
		MX: "MEX",
		MY: "MYS",
		MZ: "MOZ",
		NA: "NAM",
		NC: "NCL",
		NE: "NER",
		NF: "NFK",
		NG: "NGA",
		NI: "NIC",
		NL: "NLD",
		NO: "NOR",
		NP: "NPL",
		NR: "NRU",
		NU: "NIU",
		NZ: "NZL",
		OM: "OMN",
		PA: "PAN",
		PE: "PER",
		PF: "PYF",
		PG: "PNG",
		PH: "PHL",
		PK: "PAK",
		PL: "POL",
		PM: "SPM",
		PN: "PCN",
		PR: "PRI",
		PT: "PRT",
		PW: "PLW",
		PY: "PRY",
		QA: "QAT",
		RE: "REU",
		RO: "ROU",
		RS: "SRB",
		RU: "RUS",
		RW: "RWA",
		SA: "SAU",
		SB: "SLB",
		SC: "SYC",
		SD: "SDN",
		SE: "SWE",
		SG: "SGP",
		SH: "SHN",
		SI: "SVN",
		SJ: "SJM",
		SK: "SVK",
		SL: "SLE",
		SM: "SMR",
		SN: "SEN",
		SO: "SOM",
		SR: "SUR",
		ST: "STP",
		SV: "SLV",
		SY: "SYR",
		SZ: "SWZ",
		TC: "TCA",
		TD: "TCD",
		TF: "ATF",
		TG: "TGO",
		TH: "THA",
		TJ: "TJK",
		TK: "TKL",
		TM: "TKM",
		TN: "TUN",
		TO: "TON",
		TP: "TMP",
		TR: "TUR",
		TT: "TTO",
		TV: "TUV",
		TW: "TWN",
		TZ: "TZA",
		UA: "UKR",
		UG: "UGA",
		UM: "UMI",
		US: "USA",
		UY: "URY",
		UZ: "UZB",
		VA: "VAT",
		VC: "VCT",
		VE: "VEN",
		VG: "VGB",
		VI: "VIR",
		VN: "VNM",
		VU: "VUT",
		WF: "WLF",
		WS: "WSM",
		YE: "YEM",
		YT: "MYT",
		ZA: "ZAF",
		ZM: "ZMB",
		ZW: "ZWE",
		EU: [
			"DEU",
			"ESP",
			"FRA",
			"ITA",
			"GRC",
			"DNK",
			"SWE",
			"FIN",
			"IRL",
			"POL",
			"PRT",
			"BEL",
			"NLD",
			"LUX",
			"AUT",
			"CZE",
			"HRV",
			"SVK",
			"HUN",
			"SVN",
			"ROU",
			"BGR",
			"EST",
			"LVA",
			"LTU",
			"CYP",
			"MLT",
		],
		UN: "UN",
	},
	countryCodeHashReverse: {
		AND: "AD",
		ARE: "AE",
		AFG: "AF",
		ATG: "AG",
		AIA: "AI",
		ALB: "AL",
		ARM: "AM",
		ANT: "AN",
		AGO: "AO",
		ATA: "AQ",
		ARG: "AR",
		ASM: "AS",
		AUT: "AT",
		AUS: "AU",
		ABW: "AW",
		ALA: "AX",
		AZE: "AZ",
		BIH: "BA",
		BRB: "BB",
		BGD: "BD",
		BEL: "BE",
		BFA: "BF",
		BGR: "BG",
		BHR: "BH",
		BDI: "BI",
		BEN: "BJ",
		BLM: "BL",
		BMU: "BM",
		BRN: "BN",
		BOL: "BO",
		BRA: "BR",
		BHS: "BS",
		BTN: "BT",
		BVT: "BV",
		BWA: "BW",
		BLR: "BY",
		BLZ: "BZ",
		CAN: "CA",
		CCK: "CC",
		COD: "CD",
		CAF: "CF",
		COG: "CG",
		CHE: "CH",
		CIV: "CI",
		COK: "CK",
		CHL: "CL",
		CMR: "CM",
		CHN: "CN",
		COL: "CO",
		CRI: "CR",
		CUB: "CU",
		CPV: "CV",
		CXR: "CX",
		CYP: "CY",
		CZE: "CZ",
		DEU: "DE",
		DJI: "DJ",
		DNK: "DK",
		DMA: "DM",
		DOM: "DO",
		DZA: "DZ",
		ECU: "EC",
		EST: "EE",
		EGY: "EG",
		ESH: "EH",
		ERI: "ER",
		ESP: "ES",
		ETH: "ET",
		FIN: "FI",
		FJI: "FJ",
		FLK: "FK",
		FSM: "FM",
		FRO: "FO",
		FRA: "FR",
		FXX: "FX",
		GAB: "GA",
		GBR: "GB",
		GRD: "GD",
		GEO: "GE",
		GUF: "GF",
		GGY: "GG",
		GHA: "GH",
		GIB: "GI",
		GRL: "GL",
		GMB: "GM",
		GIN: "GN",
		GLP: "GP",
		GNQ: "GQ",
		GRC: "GR",
		GTM: "GT",
		GUM: "GU",
		GNB: "GW",
		GUY: "GY",
		HKG: "HK",
		HMD: "HM",
		HND: "HN",
		HRV: "HR",
		HTI: "HT",
		HUN: "HU",
		IDN: "ID",
		IRL: "IE",
		ISR: "IL",
		IMN: "IM",
		IND: "IN",
		IOT: "IO",
		IRQ: "IQ",
		IRN: "IR",
		ISL: "IS",
		ITA: "IT",
		JEY: "JE",
		JAM: "JM",
		JOR: "JO",
		JPN: "JP",
		KEN: "KE",
		KGZ: "KG",
		KHM: "KH",
		KIR: "KI",
		COM: "KM",
		KNA: "KN",
		PRK: "KP",
		KOR: "KR",
		KUR: "KU",
		KWT: "KW",
		KYM: "KY",
		KAZ: "KZ",
		LAO: "LA",
		LBN: "LB",
		LCA: "LC",
		LIE: "LI",
		LKA: "LK",
		LBR: "LR",
		LSO: "LS",
		LTU: "LT",
		LUX: "LU",
		LVA: "LV",
		LBY: "LY",
		MAR: "MA",
		MCO: "MC",
		MDA: "MD",
		MNE: "ME",
		MDG: "MG",
		MHL: "MH",
		MKD: "MK",
		MLI: "ML",
		MMR: "MM",
		MNG: "MN",
		MAC: "MO",
		MNP: "MP",
		MTQ: "MQ",
		MRT: "MR",
		MSR: "MS",
		MLT: "MT",
		MUS: "MU",
		MDV: "MV",
		MWI: "MW",
		MEX: "MX",
		MYS: "MY",
		MOZ: "MZ",
		NAM: "NA",
		NCL: "NC",
		NER: "NE",
		NFK: "NF",
		NGA: "NG",
		NIC: "NI",
		NLD: "NL",
		NOR: "NO",
		NPL: "NP",
		NRU: "NR",
		NIU: "NU",
		NZL: "NZ",
		OMN: "OM",
		PAN: "PA",
		PER: "PE",
		PYF: "PF",
		PNG: "PG",
		PHL: "PH",
		PAK: "PK",
		POL: "PL",
		SPM: "PM",
		PCN: "PN",
		PRI: "PR",
		PRT: "PT",
		PLW: "PW",
		PRY: "PY",
		QAT: "QA",
		REU: "RE",
		ROU: "RO",
		SRB: "RS",
		RUS: "RU",
		RWA: "RW",
		SAU: "SA",
		SLB: "SB",
		SYC: "SC",
		SDN: "SD",
		SWE: "SE",
		SGP: "SG",
		SHN: "SH",
		SVN: "SI",
		SJM: "SJ",
		SVK: "SK",
		SLE: "SL",
		SMR: "SM",
		SEN: "SN",
		SOM: "SO",
		SUR: "SR",
		STP: "ST",
		SLV: "SV",
		SYR: "SY",
		SWZ: "SZ",
		TCA: "TC",
		TCD: "TD",
		ATF: "TF",
		TGO: "TG",
		THA: "TH",
		TJK: "TJ",
		TKL: "TK",
		TKM: "TM",
		TUN: "TN",
		TON: "TO",
		TMP: "TP",
		TUR: "TR",
		TTO: "TT",
		TUV: "TV",
		TWN: "TW",
		TZA: "TZ",
		UKR: "UA",
		UGA: "UG",
		UMI: "UM",
		USA: "US",
		URY: "UY",
		UZB: "UZ",
		VAT: "VA",
		VCT: "VC",
		VEN: "VE",
		VGB: "VG",
		VIR: "VI",
		VNM: "VN",
		VUT: "VU",
		WLF: "WF",
		WSM: "WS",
		YEM: "YE",
		MYT: "YT",
		ZAF: "ZA",
		ZMB: "ZM",
		ZWE: "ZW",
		EU: "EU",
	},

	capitalGeoPositions: {
		ABW: {
			lat: "12.533",
			lon: "-70.033",
		},
		AFG: {
			lat: "34.467",
			lon: "69.183",
		},
		AGO: {
			lat: "-8.833",
			lon: "13.25",
		},
		ALB: {
			lat: "41.3",
			lon: "19.817",
		},
		AND: {
			lat: "42.517",
			lon: "1.533",
		},
		ARE: {
			lat: "24.467",
			lon: "54.367",
		},
		ARG: {
			lat: "-36.5",
			lon: "-60",
		},
		ARM: {
			lat: "40.167",
			lon: "44.517",
		},
		ASM: {
			lat: "-14.267",
			lon: "-170.717",
		},
		ATG: {
			lat: "17.333",
			lon: "-61.8",
		},
		AUS: {
			lat: "-35.25",
			lon: "149.133",
		},
		AUT: {
			lat: "48.2",
			lon: "16.367",
		},
		AZE: {
			lat: "40.483",
			lon: "49.933",
		},
		BDI: {
			lat: "-3.267",
			lon: "29.3",
		},
		BEL: {
			lat: "50.85",
			lon: "4.35",
		},
		BEN: {
			lat: "6.383",
			lon: "2.7",
		},
		BFA: {
			lat: "12.25",
			lon: "-1.5",
		},
		BGD: {
			lat: "23.717",
			lon: "90.433",
		},
		BGR: {
			lat: "42.75",
			lon: "23.333",
		},
		BHR: {
			lat: "26.167",
			lon: "50.5",
		},
		BHS: {
			lat: "25.083",
			lon: "-77.333",
		},
		BIH: {
			lat: "43.867",
			lon: "18.433",
		},
		BLR: {
			lat: "53.867",
			lon: "27.5",
		},
		BLZ: {
			lat: "17.3",
			lon: "-88.5",
		},
		BOL: {
			lat: "-16.333",
			lon: "-68.167",
		},
		BRA: {
			lat: "-15.783",
			lon: "-47.917",
		},
		BRB: {
			lat: "13.083",
			lon: "-59.5",
		},
		BTN: {
			lat: "27.517",
			lon: "89.75",
		},
		BWA: {
			lat: "-24.75",
			lon: "25.95",
		},
		CAF: {
			lat: "4.383",
			lon: "18.583",
		},
		CAN: {
			lat: "45.45",
			lon: "-75.7",
		},
		CHE: {
			lat: "46.95",
			lon: "7.467",
		},
		CHL: {
			lat: "-33.4",
			lon: "-70.667",
		},
		CHN: {
			lat: "39.917",
			lon: "116.333",
		},
		CMR: {
			lat: "3.833",
			lon: "11.583",
		},
		COD: {
			lat: "-4.333",
			lon: "15.25",
		},
		COL: {
			lat: "4.567",
			lon: "-74",
		},
		CPV: {
			lat: "15.033",
			lon: "-23.567",
		},
		CRI: {
			lat: "9.917",
			lon: "-84.033",
		},
		CUB: {
			lat: "23.133",
			lon: "-82.367",
		},
		CYM: {
			lat: "19.333",
			lon: "-81.4",
		},
		CYP: {
			lat: "35.167",
			lon: "33.417",
		},
		CZE: {
			lat: "50.083",
			lon: "14.367",
		},
		DEU: {
			lat: "52.5",
			lon: "13.417",
		},
		DJI: {
			lat: "11.133",
			lon: "42.333",
		},
		DMA: {
			lat: "15.333",
			lon: "-61.4",
		},
		DNK: {
			lat: "55.683",
			lon: "12.567",
		},
		DZA: {
			lat: "36.7",
			lon: "3.133",
		},
		ECU: {
			lat: "-0.25",
			lon: "-78.583",
		},
		EGY: {
			lat: "30.017",
			lon: "31.233",
		},
		ERI: {
			lat: "15.317",
			lon: "38.917",
		},
		ESP: {
			lat: "40.417",
			lon: "-3.75",
		},
		EST: {
			lat: "59.367",
			lon: "24.8",
		},
		ETH: {
			lat: "9.033",
			lon: "38.7",
		},
		FIN: {
			lat: "60.25",
			lon: "25.05",
		},
		FJI: {
			lat: "-18.1",
			lon: "178.5",
		},
		FRA: {
			lat: "48.833",
			lon: "2.333",
		},
		FRO: {
			lat: "62.083",
			lon: "-6.933",
		},
		GAB: {
			lat: "0.417",
			lon: "9.433",
		},
		GBR: {
			lat: "51.6",
			lon: "-0.083",
		},
		GEO: {
			lat: "41.717",
			lon: "44.833",
		},
		GGY: {
			lat: "49.433",
			lon: "-2.55",
		},
		GHA: {
			lat: "5.583",
			lon: "-0.1",
		},
		GIN: {
			lat: "9.483",
			lon: "-13.817",
		},
		GLP: {
			lat: "16",
			lon: "-61.733",
		},
		GMB: {
			lat: "13.467",
			lon: "-16.667",
		},
		GNB: {
			lat: "11.75",
			lon: "-15.75",
		},
		GNQ: {
			lat: "3.75",
			lon: "8.833",
		},
		GRC: {
			lat: "37.967",
			lon: "23.767",
		},
		GRL: {
			lat: "64.167",
			lon: "-51.583",
		},
		GTM: {
			lat: "14.667",
			lon: "-90.367",
		},
		GUF: {
			lat: "5.083",
			lon: "-52.3",
		},
		GUY: {
			lat: "6.833",
			lon: "-58.2",
		},
		HMD: {
			lat: "-53",
			lon: "74",
		},
		HND: {
			lat: "14.083",
			lon: "-87.233",
		},
		HRV: {
			lat: "45.833",
			lon: "15.967",
		},
		HTI: {
			lat: "18.667",
			lon: "-72.333",
		},
		HUN: {
			lat: "47.483",
			lon: "19.083",
		},
		IDN: {
			lat: "-6.15",
			lon: "106.817",
		},
		IND: {
			lat: "28.617",
			lon: "77.217",
		},
		IRL: {
			lat: "53.35",
			lon: "-6.25",
		},
		IRQ: {
			lat: "33.333",
			lon: "44.5",
		},
		ISL: {
			lat: "64.167",
			lon: "-21.95",
		},
		ISR: {
			lat: "31.783",
			lon: "35.2",
		},
		ITA: {
			lat: "41.9",
			lon: "12.483",
		},
		JAM: {
			lat: "18",
			lon: "-76.833",
		},
		JOR: {
			lat: "31.95",
			lon: "35.867",
		},
		JPN: {
			lat: "35.683",
			lon: "139.767",
		},
		KAZ: {
			lat: "51.167",
			lon: "71.5",
		},
		KEN: {
			lat: "-1.283",
			lon: "36.8",
		},
		KGZ: {
			lat: "42.9",
			lon: "74.767",
		},
		KHM: {
			lat: "11.55",
			lon: "104.917",
		},
		KIR: {
			lat: "1.5",
			lon: "173",
		},
		KNA: {
			lat: "17.283",
			lon: "-62.717",
		},
		KOR: {
			lat: "37.517",
			lon: "126.967",
		},
		KWT: {
			lat: "29.5",
			lon: "48",
		},
		LAO: {
			lat: "17.967",
			lon: "102.6",
		},
		LBN: {
			lat: "33.883",
			lon: "35.517",
		},
		LBR: {
			lat: "6.3",
			lon: "-10.783",
		},
		LCA: {
			lat: "14.033",
			lon: "-60.967",
		},
		LIE: {
			lat: "47.133",
			lon: "9.517",
		},
		LSO: {
			lat: "-29.3",
			lon: "27.5",
		},
		LTU: {
			lat: "54.633",
			lon: "25.317",
		},
		LUX: {
			lat: "49.617",
			lon: "6.15",
		},
		LVA: {
			lat: "56.883",
			lon: "24.133",
		},
		MAR: {
			lat: "34.033",
			lon: "-6.833",
		},
		MDG: {
			lat: "-18.917",
			lon: "47.517",
		},
		MDV: {
			lat: "4",
			lon: "73.467",
		},
		MEX: {
			lat: "19.333",
			lon: "-99.167",
		},
		MLI: {
			lat: "12.567",
			lon: "-7.917",
		},
		MLT: {
			lat: "35.9",
			lon: "14.517",
		},
		MMR: {
			lat: "16.75",
			lon: "96.333",
		},
		MNP: {
			lat: "15.2",
			lon: "145.75",
		},
		MOZ: {
			lat: "-25.967",
			lon: "32.533",
		},
		MRT: {
			lat: "-20.167",
			lon: "57.5",
		},
		MTQ: {
			lat: "14.6",
			lon: "-61.033",
		},
		MWI: {
			lat: "-14",
			lon: "33.8",
		},
		MYS: {
			lat: "3.15",
			lon: "101.683",
		},
		MYT: {
			lat: "-12.8",
			lon: "45.233",
		},
		NAM: {
			lat: "-22.583",
			lon: "17.067",
		},
		NCL: {
			lat: "-22.283",
			lon: "166.5",
		},
		NER: {
			lat: "13.45",
			lon: "2.1",
		},
		NFK: {
			lat: "-45.333",
			lon: "168.717",
		},
		NGA: {
			lat: "9.083",
			lon: "7.533",
		},
		NIC: {
			lat: "12.1",
			lon: "-86.333",
		},
		NLD: {
			lat: "52.383",
			lon: "4.9",
		},
		NOR: {
			lat: "59.917",
			lon: "10.75",
		},
		NPL: {
			lat: "27.75",
			lon: "85.333",
		},
		NZL: {
			lat: "-41.317",
			lon: "174.767",
		},
		OMN: {
			lat: "23.617",
			lon: "58.6",
		},
		PAK: {
			lat: "33.667",
			lon: "73.167",
		},
		PAN: {
			lat: "9",
			lon: "-79.417",
		},
		PER: {
			lat: "-12",
			lon: "-77",
		},
		PHL: {
			lat: "14.667",
			lon: "121.05",
		},
		PLW: {
			lat: "7.333",
			lon: "134.467",
		},
		PNG: {
			lat: "-9.4",
			lon: "147.133",
		},
		POL: {
			lat: "52.217",
			lon: "21",
		},
		PRI: {
			lat: "18.467",
			lon: "-66.117",
		},
		PRT: {
			lat: "38.7",
			lon: "-9.167",
		},
		PRY: {
			lat: "-25.167",
			lon: "-57.5",
		},
		PYF: {
			lat: "-17.533",
			lon: "-149.567",
		},
		QAT: {
			lat: "25.25",
			lon: "51.583",
		},
		ROU: {
			lat: "44.45",
			lon: "26.167",
		},
		RUS: {
			lat: "55.75",
			lon: "37.583",
		},
		SAU: {
			lat: "24.683",
			lon: "46.7",
		},
		SDN: {
			lat: "15.517",
			lon: "32.583",
		},
		SEN: {
			lat: "14.567",
			lon: "-17.483",
		},
		SLB: {
			lat: "-9.45",
			lon: "159.95",
		},
		SLE: {
			lat: "8.5",
			lon: "-13.283",
		},
		SLV: {
			lat: "13.667",
			lon: "-89.167",
		},
		SMR: {
			lat: "43.917",
			lon: "12.5",
		},
		SOM: {
			lat: "2.033",
			lon: "45.417",
		},
		SPM: {
			lat: "46.767",
			lon: "-56.2",
		},
		SUR: {
			lat: "5.833",
			lon: "-55.167",
		},
		SVK: {
			lat: "48.167",
			lon: "17.117",
		},
		SVN: {
			lat: "46.067",
			lon: "14.55",
		},
		SWE: {
			lat: "59.333",
			lon: "18.05",
		},
		SWZ: {
			lat: "-26.3",
			lon: "31.1",
		},
		SYR: {
			lat: "33.5",
			lon: "36.3",
		},
		TCD: {
			lat: "12.167",
			lon: "14.983",
		},
		TGO: {
			lat: "6.15",
			lon: "1.333",
		},
		THA: {
			lat: "13.75",
			lon: "100.583",
		},
		TJK: {
			lat: "38.55",
			lon: "68.8",
		},
		TKM: {
			lat: "38",
			lon: "57.833",
		},
		TON: {
			lat: "-21.167",
			lon: "-174",
		},
		TUN: {
			lat: "36.833",
			lon: "10.183",
		},
		TUR: {
			lat: "39.95",
			lon: "32.9",
		},
		TUV: {
			lat: "-8.517",
			lon: "179.217",
		},
		TZA: {
			lat: "-6.133",
			lon: "35.75",
		},
		UGA: {
			lat: "0.333",
			lon: "32.5",
		},
		UKR: {
			lat: "50.5",
			lon: "30.467",
		},
		URY: {
			lat: "-34.833",
			lon: "-56.183",
		},
		USA: {
			lat: "40.517",
			lon: "-77.033",
		},
		UZB: {
			lat: "41.333",
			lon: "69.167",
		},
		VEN: {
			lat: "10.5",
			lon: "-66.917",
		},
		VGB: {
			lat: "18.45",
			lon: "-64.617",
		},
		VUT: {
			lat: "-17.75",
			lon: "168.3",
		},
		WSM: {
			lat: "-13.833",
			lon: "-171.833",
		},
		ZAF: {
			lat: "-25.733",
			lon: "28.2",
		},
		ZMB: {
			lat: "-15.467",
			lon: "28.267",
		},
		ZWE: {
			lat: "-17.717",
			lon: "31.033",
		},
		EU: {
			lat: "50.85",
			lon: "4.35",
		}, // take the capital of Belgium as EU's capital
		UN: {
			lat: "78.23",
			lon: "15.49",
		}, // take Svalbard for the UN: 78.235867, 15.491374
	},

	euCountryNames: {
		de: {
			AUT: "Österreich",
			BEL: "Belgien",
			BGR: "Bulgarien",
			CYP: "Zypern",
			CZE: "Tschechien",
			DEU: "Deutschland",
			DNK: "Dänemark",
			ESP: "Spanien",
			EST: "Estland",
			FIN: "Finnland",
			FRA: "Frankreich",
			GBR: "Vereinigtes Königreich",
			GRC: "Griechenland",
			HRV: "Kroatien",
			HUN: "Ungarn",
			IRL: "Irland",
			ITA: "Italien",
			LTU: "Litauen",
			LUX: "Luxembourg",
			LVA: "Lettland",
			MLT: "Malta",
			NLD: "Niederlande",
			POL: "Polen",
			PRT: "Portugal",
			ROU: "Rumänien",
			SVK: "Slowakei",
			SVN: "Slowenien",
			SWE: "Schweden",
		},
		en: {
			AUT: "Austria",
			BEL: "Belgium",
			BGR: "Bulgaria",
			CYP: "Cyprus",
			CZE: "Czechia",
			DEU: "Germany",
			DNK: "Denmark",
			ESP: "Spain",
			EST: "Estonia",
			FIN: "Finland",
			FRA: "France",
			GBR: "United Kingdom",
			GRC: "Greece",
			HRV: "Croatia",
			HUN: "Hungary",
			IRL: "Ireland",
			ITA: "Italy",
			LTU: "Lithuania",
			LUX: "Luxemburg",
			LVA: "Latvia",
			MLT: "Malta",
			NLD: "Netherlands",
			POL: "Poland",
			PRT: "Portugal",
			ROU: "Romania",
			SVK: "Slovakia",
			SVN: "Slovenia",
			SWE: "Sweden",
		},
	},
};
